module.exports = __webpack_public_path__ + "img/avatar.1f9d44e6.png";